<cookie-law expiration="365">Vi bruger cookies for at forbedre brugeroplevelsen. Ved brug af Cicero Move accepterer du vores
  <a href="/move/assets/static/cookiesDanish.html">brug af cookies.</a>
</cookie-law>



// WEBPACK FOOTER //
// ./src/app/cookie/cookie/cookie.component.html